<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: GPSWeekModal.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="gps-week-modal modal" tabindex="-1" role="dialog">
    <div class="gps-week-modal__dialog modal-dialog" role="document" :style="modalDialogStyle">
      <div class="modal-content">
        <!-- <div class="modal-header">
          <h5 class="modal-title">Day Of Year</h5>
          <button
            type="button"
            class="day-modal__close close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$emit('closeModal')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div> -->
        <div class="modal-side">
          <ul class="modal-side__menu">
            <li class="modal-side__button selected">GPS Week</li>
            <li class="modal-side__button" @click="goToDOY" data-dismiss="modal">Day of Year</li>
            <li class="modal-side__button" @click="goToCalendarDay" data-dismiss="modal">Calendar Day</li>
          </ul>
        </div>
        <div class="modal-body">
          <form autocomplete="off">
            <!-- An option to have + and - buttons -->
            <!-- <div class="input-group">
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-default btn-number"
                  disabled="disabled"
                  data-type="minus"
                  data-field="quant[1]"
                >
                  <span class="glyphicon glyphicon-minus"></span>
                </button>
              </span>
              <input type="text" name="quant[1]" class="form-control input-number" value="8" min="8" max="30" />
              <span class="input-group-btn">
                <button type="button" class="btn btn-default btn-number" data-type="plus" data-field="quant[1]">
                  <span class="glyphicon glyphicon-plus"></span>
                </button>
              </span>
            </div> -->
            <div class="form-group form-inline justify-content-between">
              <!-- <label for="name">Day Of Year</label>
              <input
                v-model="day"
                type="number"
                class="edit-lab-modal__name form-control"
                id="name"
                min="1"
                max="366"
              /> -->
              <div class="reference">For reference: current GPS Week is: {{ currentWeek }}</div>
              <div class="reference second-line">
                Format: wwww-W (W: 0:Sun 1:Mon ... 6:Sat) or wwww-W-HHMM to select time
              </div>
              <label for="week-from">From</label>
              <input
                @keyup="weekFromChanged"
                @change="weekFromUpdated"
                type="text"
                v-model="weekFrom"
                class="gps-week-modal__input form-control"
                id="week-from"
                placeholder="wwww-W-HHMM"
              />
              <div class="day-extracted">
                {{ momFLabel }}
              </div>
              <label for="week-to">To</label>
              <input
                @keyup="weekToChanged"
                type="text"
                v-model="weekTo"
                class="gps-week-modal__input form-control"
                id="week-to"
                placeholder="wwww-W-HHMM"
              />
              <div class="day-extracted">
                {{ momTLabel }}
              </div>
              <div class="error-message">{{ errorMessage }}</div>
            </div>
            <!-- <div class="form-group">
              <label for="description">Description</label>
              <textarea
                v-model="desc"
                type="text"
                class="edit-lab-modal__desc form-control"
                id="description"
                disabled
              />
            </div> -->
            <div class="gps-week-modal__button-wrapper">
              <button
                type="button"
                class="gps-week-modal__cancel btn btn-primary"
                data-dismiss="modal"
                @click="closeModal"
              >
                Cancel
              </button>
              <button
                class="gps-week-modal__apply btn btn-primary"
                type="submit"
                @click.prevent="emitRangeFrom"
                :disabled="applyDisabled"
              >
                Apply
              </button>
            </div>
          </form>
        </div>
        <!-- <div class="modal-footer"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { emit } from 'process'

export default {
  name: 'GPSWeekModal',
  props: {
    datePickerLocation: {
      type: Object,
    },
  },
  data() {
    return {
      weekFrom: '',
      weekTo: '',
      weekDayFCheck: 0,
      weekDayTCheck: 6,
      // momF: null,
      // momT: null,
      // dayFromValid: false,
      // dayToValid: false,
      // errorMessage: '',
    }
  },
  computed: {
    currentWeek() {
      const secondsWeek = 604800
      const GPS_OFFSET_SEC = 315964800
      const GPS_TIME_LEAP = 18
      const d = new Date()
      const tzOffset = d.getTimezoneOffset()
      const absoluteTime = parseInt((d.getTime() - d.getTimezoneOffset()) / 1000 - GPS_OFFSET_SEC + GPS_TIME_LEAP)
      const currentGPSWeek = parseInt(absoluteTime / secondsWeek)
      return currentGPSWeek
    },
    momFLabel() {
      return moment(this.momF).isValid()
        ? this.momF.format('YYYY-MM-DD HH:mm')
        : this.dayFrom !== ''
        ? '' //'wwww-W (W: 0:Sun 1:Mon ... 6:Sat)'
        : ''
    },
    momTLabel() {
      return moment(this.momT).isValid()
        ? this.momT.format('YYYY-MM-DD HH:mm')
        : this.dayTo !== ''
        ? '' //'wwww-W (W: 0:Sun 1:Mon ... 6:Sat)'
        : ''
    },
    modalDialogStyle() {
      console.log(this.datePickerLocation)
      return this.datePickerLocation
    },
    momF() {
      let weekF, weekDayF, timeF, hourF, minF
      if (this.weekFrom.match(/-/g) && this.weekFrom.match(/-/g).length === 2) {
        ;[weekF, weekDayF, timeF] = this.weekFrom.split('-')
        hourF = timeF.substring(0, 2) || '00'
        minF = timeF.substring(2) || '00'
      } else if (this.weekFrom.match(/-/g) && this.weekFrom.match(/-/g).length === 1) {
        ;[weekF, weekDayF] = this.weekFrom.split('-')
        this.weekDayFCheck = weekDayF
      } else {
        weekF = this.weekFrom
        weekDayF = 0
      }
      return this.weekFrom.length > 0
        ? moment('19800106')
            .add(parseInt(weekF), 'weeks')
            .add(parseInt(weekDayF), 'days')
            .add(parseInt(hourF), 'hours')
            .add(parseInt(minF), 'minutes')
        : null
    },
    momT() {
      let weekT, weekDayT, timeT, hourT, minT
      hourT = '23'
      minT = '59'
      if (this.weekTo.match(/-/g) && this.weekTo.match(/-/g).length === 2) {
        ;[weekT, weekDayT, timeT] = this.weekTo.split('-')
        hourT = timeT.substring(0, 2) || '23'
        minT = timeT.substring(2) || '59'
      } else if (this.weekTo.match(/-/g) && this.weekTo.match(/-/g).length === 1) {
        ;[weekT, weekDayT] = this.weekTo.split('-')
        this.weekDayTCheck = weekDayT
      } else {
        weekT = this.weekTo
        weekDayT = 6
      }
      return this.weekTo.length > 0
        ? moment('19800106')
            .add(parseInt(weekT), 'weeks')
            .add(parseInt(weekDayT), 'days')
            .add(parseInt(hourT), 'hours')
            .add(parseInt(minT), 'minutes')
        : null

      // return this.weekTo.length > 0
      //   ? moment('19800106')
      //       .add(this.weekTo, 'weeks')
      //       .endOf('week')
      //   : null
    },
    errorMessage() {
      let errorMessage = ''
      if (this.momF && this.momT) {
        if (this.momF.isAfter(this.momT)) {
          errorMessage = '"To Week" must be the same or after "From Week"'
        }
      }
      if (this.weekDayFCheck > 6 || this.weekDayTCheck > 6) {
        errorMessage = 'Day of week must be between 0 and 6'
      }
      if (this.momF) {
        if (this.momF.isAfter(moment())) {
          errorMessage = 'The period selected must be in the past'
        }
      }
      if (this.momT) {
        if (this.momT.isAfter(moment())) {
          errorMessage = 'The period selected must be in the past'
        }
      }
      return errorMessage
    },
    applyDisabled() {
      return !this.momF || !this.momT || this.errorMessage != ''
    },
  },
  methods: {
    weekFromChanged(e) {
      // this.weekTo = this.weekFrom

      if (this.weekFrom.length == 4 && e.key != 'Backspace' && e.key != 'Delete') {
        this.weekFrom = this.weekFrom.slice(0, 4) + '-0-' // + this.weekFrom.slice(4)
      }
      // console.log(
      //   'day from would be:',
      //   moment('19800106')
      //     .add(parseInt(this.weekFrom), 'weeks')
      //     .format('YYYY-MM-DD HH:mm'),
      // )
      // this.momF = moment('19800106').add(parseInt(this.weekFrom), 'weeks')

      // if (this.dayFrom.match(/\//g) && this.dayFrom.match(/\//g).length === 2) {
      //   let [yearF, dayF, timeF] = this.dayFrom.split('/')
      //   let hourF = timeF.substring(0, 2)
      //   let minF = timeF.substring(2)
      //   // console.log(yearF, dayF, timeF, hourF, minF, this.dayFrom)
      //   this.momF = moment()
      //     .year(yearF)
      //     .dayOfYear(dayF)
      //     .hour(hourF)
      //     .minute(minF)
      //     .second(0)
      //   // .format('YYYY-MM-DD HH:mm')
      //   this.dayFromValid = true
      // } else
      // if (this.weekFrom.match(/-/g) && this.weekFrom.match(/-/g).length === 1) {
      //   let [weekF, dayF] = this.weekFrom.split('-')
      //   this.momF = moment()
      //     .year(yearF)
      //     .dayOfYear(dayF)
      //     .hour(0)
      //     .minute(0)
      //     .second(0)
      //   // .format('YYYY-MM-DD HH:mm')
      //   this.dayFromValid = true
      // } else {
      //   this.momF = null
      //   this.dayFromValid = false
      // }
      // if (this.dayFromValid && this.dayToValid) {
      //   if (this.momF.isAfter(this.momT)) {
      //     this.errorMessage = '"Day To" must be after "Day From"'
      //   } else {
      //     this.errorMessage = ''
      //   }
      // }
    },
    weekToChanged(e) {
      if (this.weekTo.length == 4 && e.key != 'Backspace' && e.key != 'Delete') {
        this.weekTo = this.weekTo.slice(0, 4) + '-6-' // + this.weekTo.slice(4)
      }
      // console.log(
      //   'day to would be:',
      //   moment('19800106')
      //     .add(this.weekTo, 'weeks')
      //     .endOf('week')
      //     .format('YYYY-MM-DD HH:mm'),
      // )
      // this.momT = moment('19800106')
      //   .add(this.weekTo, 'weeks')
      //   .endOf('week')
      // if (this.dayTo.match(/\//g) && this.dayTo.match(/\//g).length === 2) {
      //   let [yearT, dayT, timeT] = this.dayTo.split('/')
      //   let hourT = timeT.substring(0, 2)
      //   let minT = timeT.substring(2)
      //   // console.log(yearT, dayT, timeT, hourT, minT, this.dayTo)
      //   this.momT = moment()
      //     .year(yearT)
      //     .dayOfYear(dayT)
      //     .hour(hourT)
      //     .minute(minT)
      //     .second(0)
      //   this.dayToValid = true
      // } else if (this.dayTo.match(/\//g) && this.dayTo.match(/\//g).length === 1) {
      //   let [yearT, dayT] = this.dayTo.split('/')
      //   this.momT = moment()
      //     .year(yearT)
      //     .dayOfYear(dayT)
      //     .hour(0)
      //     .minute(0)
      //     .second(0)
      //   this.dayToValid = true
      // } else {
      //   this.momT = null
      //   this.dayToValid = false
      // }
      // if (this.dayFromValid && this.dayToValid) {
      //   if (this.momF.isAfter(this.momT)) {
      //     this.errorMessage = '"Day To" must be after "Day From"'
      //   } else {
      //     this.errorMessage = ''
      //   }
      // }
    },
    weekFromUpdated() {
      // console.log('UPDATED')
    },
    emitRangeFrom() {
      if (this.weekFrom.length > 0 && this.weekTo.length > 0 && this.errorMessage == '') {
        this.$emit('gpsWeek', this.momF, this.momT)
        this.clearFields()
      }
    },
    closeModal() {
      this.$emit('closeModal')
      this.clearFields()
    },
    clearFields() {
      this.weekFrom = ''
      this.weekTo = ''
      // this.momF = null
      // this.momT = null
      // this.dayFromValid = false
      // this.dayToValid = false
      // this.errorMessage = ''
    },
    goToDOY() {
      this.closeModal()
      this.$emit('openDOY')
    },
    goToCalendarDay() {
      this.closeModal()
      this.$emit('openCalendarDay')
    },
  },
  mounted() {},
  // watch: {
  //   datePickerLocation(value) {
  //     console.log('datepicker loc', value, this.datePickerLocation)
  //   },
  // },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';
@import '~@/styles/globals';
.gps-week-modal {
  &__dialog.modal-dialog {
    position: absolute;
    left: 255px;
    top: 25px;
    margin-top: 45px !important;

    // margin: 0 !important;

    .modal-content {
      position: relative;
      border-radius: 4px !important;
      width: 420px;
      font-size: 12px;
      display: flex;
      flex-direction: row;
      .modal-side {
        border: 1px solid #ddd;
        border-right: none;
        &__menu {
          margin-top: 8px;
          padding-left: unset;
          list-style: none;
        }
        &__button {
          min-width: 140px;
          padding: 8px 12px;
          line-height: 1.3;
          cursor: pointer;
          &:hover {
            background-color: #eee;
          }
          &.selected {
            background-color: $primary;
            color: white;
          }
        }
      }
      .modal-body {
        border: 1px solid #ddd !important;
        padding: 12px;
        .second-line {
          height: 42px;
        }
      }
      &::before {
        content: '';
        position: absolute;
        left: 10px;
        top: -6px;
        border-right: 7px solid transparent;
        border-left: 7px solid transparent;
        border-bottom: 7px solid #ccc;
      }
      &::after {
        content: '';
        position: absolute;
        left: 11px;
        top: -5px;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
        border-left: 6px solid transparent;
      }
      @include media-breakpoint-down(xs) {
        width: 260px;
        flex-direction: column;
      }
    }
    .day-extracted,
    .reference {
      margin-top: 2px;
      margin-right: 2px;
      height: 20px;
      width: 100%;
      font-size: 12px;
      text-align: right;
      color: $deep-space-2;
      font-style: oblique;
    }
    .reference {
      text-align: left;
      &.second-line {
        margin-bottom: 6px;
      }
    }
    .error-message {
      height: 21px;
      width: 100%;
      font-size: 12px;
      color: $enlight-yellow--2;
      font-style: oblique;
    }
  }
  &__input.form-control {
    padding: 2px 10px;
    font-size: 12px;
    height: unset;
  }
  &__button-wrapper {
    display: flex;
    justify-content: flex-end;
  }
  &__apply.btn,
  &__cancel.btn {
    margin-left: 12px;
    font-size: 12px;
  }
}
</style>
